import axios from '../utils/axios'

export function planlist(params) {//竞赛列表
  return axios.post('/GrowthPlanning/list', params);
}



